import loadProjectActions from './actions';

export default {
    ...loadProjectActions,
};
